import qs from 'qs';

import { ServiceError } from 'src/lib/errors';
import { config } from 'src/lib/config';
import { AbstractService } from 'src/services/AbstractService';

class ConsolidationConfigurationApi extends AbstractService implements Services.IngestConfigApi.ConsolidationConfiguration {
    public async getConsolidationConfiguration(
        bearerToken: string | undefined | false,
        productKey: string,
        signal?: AbortSignal,
    ): Promise<Models.IngestConfigApi.ConsolidationConfiguration | null> {
        if (!bearerToken) {
            throw new ServiceError({
                message: 'Unable to perform request getConsolidationConfiguration. No bearerToken provided.',
            });
        }

        const url = `api/${this.version}/consolidationConfig/${productKey}`;
        const searchParams = qs.stringify({
            requestor: config.appName,
        });

        try {
            return await this.api
                .get(url, {
                    searchParams,
                    signal,
                    headers: {
                        Authorization: `Bearer ${bearerToken}`,
                    },
                })
                .json<Models.IngestConfigApi.ConsolidationConfiguration>();
        } catch (e: any) {
            if (e.response?.status === 404) {
                return null;
            }
            throw new ServiceError({
                ...(e as Error),
                message: 'Failed to fetch consolidation configuration',
                info: (e as Error).message,
                url,
                searchParams,
            });
        }
    }

    public async createConsolidationConfig(
        bearerToken: string | undefined | false,
        body: Models.IngestConfigApi.ConsolidationConfiguration,
        signal?: AbortSignal,
    ): Promise<Models.IngestConfigApi.ConsolidationConfiguration> {
        if (!bearerToken) {
            throw new ServiceError({
                message: 'Unable to perform request createConsolidationConfig. No bearerToken provided.',
            });
        }

        const url = `api/${this.version}/consolidationconfig`;
        const searchParams = qs.stringify({
            requestor: config.appName,
        });

        try {
            return await this.api
                .post(url, {
                    json: body,
                    searchParams,
                    signal,
                    headers: {
                        Authorization: `Bearer ${bearerToken}`,
                    },
                })
                .json<Models.IngestConfigApi.ConsolidationConfiguration>();
        } catch (e) {
            throw new ServiceError({
                ...(e as Error),
                message: 'Failed to create product association',
                info: (e as Error).message,
                url,
                searchParams,
            });
        }
    }

    public async updateConsolidationConfig(
        bearerToken: string | undefined | false,
        productKey: string,
        body: Models.IngestConfigApi.ConsolidationConfiguration,
        signal?: AbortSignal,
    ): Promise<Models.IngestConfigApi.ConsolidationConfiguration> {
        if (!bearerToken) {
            throw new ServiceError({
                message: 'Unable to perform request updateConsolidationConfig. No bearerToken provided.',
            });
        }

        const url = `api/${this.version}/consolidationConfig/${productKey}`;
        const searchParams = qs.stringify({
            requestor: config.appName,
        });

        try {
            return await this.api
                .put(url, {
                    json: body,
                    searchParams,
                    signal,
                    headers: {
                        Authorization: `Bearer ${bearerToken}`,
                    },
                })
                .json<Models.IngestConfigApi.ConsolidationConfiguration>();
        } catch (e) {
            throw new ServiceError({
                ...(e as Error),
                message: 'Failed to update product association',
                info: (e as Error).message,
                url,
                searchParams,
            });
        }
    }
}

export const ConsolidationConfigurationService = new ConsolidationConfigurationApi(config.services.ingestConfigServiceApi);
